import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

import { COMMUNICATION_PREFERENCES_URL } from 'Constants';
import { CommunicationPreferences } from '../Types/CommunicationPreferences';
import { communicationPreferenceKeys } from './communicationPreferenceKeys';

/**
 * A customer's communication preferences.
 *
 * Pass no `userId` for the signed-in customer's own: that route takes no id at all, so it cannot be
 * pointed at anyone else. Passing one uses the staff route, which is authorised separately and
 * reports the wider set of controls staff may change.
 */
export const useCommunicationPreferences = (userId?: string) =>
	useQuery<CommunicationPreferences, Error>({
		queryKey: userId
			? communicationPreferenceKeys.forUser(userId)
			: communicationPreferenceKeys.mine(),
		queryFn: async () => {
			const url = userId ? `${COMMUNICATION_PREFERENCES_URL}/${userId}` : COMMUNICATION_PREFERENCES_URL;
			const { data } = await axios.get<CommunicationPreferences>(url);
			return data;
		},
	});
